import {
  CombinedClevertapProps,
  dataLayer,
} from "@repo/analytics/data-layer-utils";
import {
  componentNameConstants,
  dlElementConstants,
  dlSectionTitleConstants,
  dlEventConstants,
  cleverTapJourneyNames,
} from "@repo/analytics/data-layer.constants";
import { getPageType } from "@repo/shared-utils/common-utils";

/**
 * Handles GA tracking for Demat account button clicks
 * @param buttonText - The text displayed on the button
 * @param compName - Company name for tracking
 */
export const handleDematAccountDL = (
  loginStatus: string,
  buttonText: string,
  compName: string,
) => {
  const data = {
    component: dlElementConstants.DEMAT_ACCOUNT_CTA,
    event: dlEventConstants.BUTTON_CLICK,
    element: dlElementConstants.OPEN_DEMAT_BUTTON,
    section_title: dlSectionTitleConstants.OPEN_DEMAT_ACCOUNT,
  };

  const cleverTapObj = {
    EP_CTA: buttonText,
    EP_STOCK_NAME: compName,
    EP_TYPE: "stock",
    EP_PRODUCT: compName,
    EP_JOURNEY_NAME: cleverTapJourneyNames.TRADING_MALL_STOCK_PDP,
  };

  dataLayer(loginStatus, data, cleverTapObj);
};

/**
 * Handles tracking for BFSL redirect page view event
 */
export function handleViewDL(pageName: string) {
  // Define analytics data object
  const data = {
    event: dlEventConstants.CLICK,
    EVENT_NAME: getPageType("tag-7"),
    EP_PAGE_NAME: pageName,
    EP_JOURNEY_NAME: "TRADING MALL PDP",
  };

  // Use same data for CleverTap object
  const cleverTapObj = {
    event: data.event,
    EVENT_NAME: data.EVENT_NAME,
    EP_PAGE_NAME: data.EP_PAGE_NAME,
    EP_JOURNEY_NAME: data.EP_JOURNEY_NAME,
  };

  dataLayer("", data, cleverTapObj);
}

/**
 * Handles tracking for BFSL redirect click event with action type
 * @param ctaType - Type of CTA that was clicked (SKIP/CONTINUE/APP BACK etc.)
 */
export function handleClickDL(
  ctaType: string,
  pageName: string,
  cleverTapProps: CombinedClevertapProps = {},
) {
  // Define analytics data object
  const data = {
    event: dlEventConstants.CLICK,
    EVENT_NAME: getPageType("tag-8"),
    EP_PAGE_NAME: pageName,
    EP_JOURNEY_NAME: "TRADING MALL PDP",
    EP_CTA: ctaType,
  };

  // Use same data for CleverTap object
  const cleverTapObj = {
    ...cleverTapProps,
    event: data.event,
    EVENT_NAME: data.EVENT_NAME,
    EP_PAGE_NAME: data.EP_PAGE_NAME,
    EP_JOURNEY_NAME: data.EP_JOURNEY_NAME,
    EP_CTA: data.EP_CTA,
  };

  dataLayer("", data, cleverTapObj);
}

export function handleShowOTPModalDL() {
  // Define analytics data object
  const data = {
    event: dlEventConstants.CLICK,
    EVENT_NAME: getPageType("tag-7"),
    EP_PAGE_NAME: "OTP VERIFICATION PAGE",
    EP_JOURNEY_NAME: "TRADING MALL PDP",
  };

  // Use same data for CleverTap object
  const cleverTapObj = {
    event: data.event,
    EVENT_NAME: data.EVENT_NAME,
    EP_PAGE_NAME: data.EP_PAGE_NAME,
    EP_JOURNEY_NAME: data.EP_JOURNEY_NAME,
  };

  dataLayer("", data, cleverTapObj);
}
